import React from 'react'
import { useParams, useResolvedPath, useNavigate, Link, NavLink } from 'react-router-dom'
import { Button, Dropdown, Menu, Space } from 'antd'
import { DownOutlined, ArrowLeftOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import useCoursePrivilege from '../../hooks/useCourseprivilege'

const CourseMenu = ({ url, privilege }) => {
  return (
    <Menu>
      <Menu.Item>
        <Link to={`${url}/announcements`}>Announcements</Link>
      </Menu.Item>
      <Menu.Item>
        <Link to={`${url}/gradebook`}>Gradebook</Link>
      </Menu.Item>
      <Menu.Item>
        <Link to={`${url}/discussions`}>Discussions</Link>
      </Menu.Item>
      {privilege !== 'student' && (
        <Menu.Item>
          <Link to={`${url}/participants`}>Participants</Link>
        </Menu.Item>
      )}
      {privilege !== 'student' && (
        <Menu.Item>
          <Link to={`${url}/settings`}>Settings</Link>
        </Menu.Item>
      )}
    </Menu>
  )
}

const CourseNavigation = ({courseMatch}) => {
  const navigate = useNavigate()

  const course = useSelector((state) =>
    state.courses.data.find((course) => course.id === courseMatch?.params?.courseId)
  )

  const { privilege } = useCoursePrivilege(courseMatch?.params?.courseId)

  const popHistory = () => {
    navigate(-1)
  }

  return (
    <>
      <style>
        {`
          .active-link button {
            font-weight: 600;
            color: #1890ff;
            border-bottom: 2px solid #1890ff;
          }
        `}
      </style>
      <Space>
        <Button
          shape="circle"
          type="secondary"
          onClick={popHistory}
          icon={<ArrowLeftOutlined />}
        ></Button>
        <Dropdown
          overlay={<CourseMenu url={courseMatch?.pathnameBase} privilege={privilege} />}
          placement="bottomCenter"
        >
          <Button
            shape="round"
            style={{ backgroundColor: course?.backgroundColor }}
          >
            <span style={{ fontWeight: 600, color: 'white' }}>
              {course?.name}
            </span>{' '}
            <DownOutlined style={{ color: 'white' }} />
          </Button>
        </Dropdown>
      </Space>
      <NavLink to={`${courseMatch?.pathnameBase}/modules`} className={({ isActive }) => (isActive ? "active-link" : "")}>
        <Button type="text">Modules</Button>
      </NavLink>
      <NavLink to={`${courseMatch?.pathnameBase}/lectures`} className={({ isActive }) => (isActive ? "active-link" : "")}>
        <Button type="text">Lectures</Button>
      </NavLink>
      <NavLink to={`${courseMatch?.pathnameBase}/assignments`} className={({ isActive }) => (isActive ? "active-link" : "")}>
        <Button type="text">Assignments</Button>
      </NavLink>
      <NavLink to={`${courseMatch?.pathnameBase}/exams`} className={({ isActive }) => (isActive ? "active-link" : "")}>
        <Button type="text">Exams</Button>
      </NavLink>
    </>
  )
}

export default CourseNavigation
